import type { WireColor } from '@/api/types/color'
import { resolvePaletteFill } from '@/lib/colors/resolve-palette-color'
import type { ShapeData } from '@/lib/shapes/types/shape-data'

const DEFAULT_SHAPE_FILL = '#e5e7eb'

function isExplicitlyNoFill(fill: string | undefined): fill is string {
  const v = fill?.trim().toLowerCase()

  return v === 'transparent' || v === 'none'
}

/**
 * The body fill to paint. A palette `fillColorId` wins over the CSS `fill` (which is only a
 * session-local mirror and is lost on reload), except when the fill is explicitly None — a text
 * frame or group keeps its transparency even if a `fillStyle` came along.
 */
export function resolveShapeBodyFill(
  shape: Pick<ShapeData, 'fill' | 'fillColorId' | 'fillTint'>,
  palette: ReadonlyMap<number, WireColor> | null
): string {
  if (isExplicitlyNoFill(shape.fill)) return shape.fill

  return (
    resolvePaletteFill(palette, shape.fillColorId, shape.fillTint) ??
    (shape.fill || DEFAULT_SHAPE_FILL)
  )
}
